import React from 'react';
import { Helmet } from 'react-helmet';
import { ErrorBoundary } from 'react-error-boundary';
import ElectricityPricing from './ElectricityPricing';

// Error fallback component
const ErrorFallback = ({ error, resetErrorBoundary }) => {
    return (
        <div className="p-4 bg-red-500/10 rounded-lg">
            <h2 className="text-xl font-bold mb-2">Something went wrong:</h2>
            <pre className="text-sm text-red-200">{error.message}</pre>
            <button 
                onClick={resetErrorBoundary}
                className="mt-4 px-4 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors"
            >
                Try again
            </button>
        </div>
    );
};

// SE3-specific configuration
const SE3_CONFIG = {
    defaultRegion: 'SE3',
    regions: ['SE3'],
    regionColors: {
        'SE3': '#edc949'
    },
    getRegionColorClass: (region) => {
        return region === 'SE3' ? 'bg-yellow-500' : 'bg-gray-500';
    },
    MapComponent: null, // No map for single region
    apiEndpoint: '/api/prices',
    countryName: 'Sverige'
};

const ElectricityPricingSE3 = () => {
    return (
        <ErrorBoundary 
            FallbackComponent={ErrorFallback}
            onReset={() => window.location.reload()}
        >
            <Helmet>
                <title>Elpriser SE3 - Dagens Elpriser</title>
                <meta name="description" content="Se aktuella elpriser för elområde SE3 (Stockholm) med realtidsdata och prognoser." />
                <meta name="keywords" content="elpriser, SE3, Stockholm, elektricitet, energi, mellansverige" />
                <link rel="canonical" href="https://dagenselpris.se/elpris-elomrade-3/" />
            </Helmet>
            <ElectricityPricing {...SE3_CONFIG} />
        </ErrorBoundary>
    );
};

export default ElectricityPricingSE3;